import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PlayerProfilePreview, DarkScreenMask, RoundCheckbox, CustomAutocomplete } from '../../..';
import "./AddPlayerToTeamModal.scss";
import ButtonsPanel from './ButtonsPanel';

const AddPlayerToTeamModal = ({ users, onClose, isVisible, onAddUsers, onInvite, accountType }) => {
  const [ selectedUsersIds, setSelectedUsersIds ] = useState([]);
  const [ filteredUsers, setFilteredUsers ] = useState([]);

  useEffect(() => {
    setFilteredUsers(users);
  }, []);

  const handleClick = user => {
    const selectedUsersCopy = [...selectedUsersIds];
    const index = selectedUsersCopy.indexOf(user._id);
    if (index > -1) {
      selectedUsersCopy.splice(index, 1);
    } else {
      selectedUsersCopy.push(user._id);
    };

    setSelectedUsersIds(selectedUsersCopy);
  };

  const onSearchChange = (value, filteredItems) => {
    if (!value) {
      setFilteredUsers([...users]);
      return;
    };

    setFilteredUsers([...filteredItems]);
  };

  return (
    <DarkScreenMask isVisible={isVisible}>
      <div className="add-player-to-team">
        <div className="add-player-to-team__close">
          <button type="button" onClick={onClose}>X</button>
        </div>
        <CustomAutocomplete
          placeholder={`Search ${accountType}`}
          items={users}
          propertyToFilterBy="fullName"
          onSelect={handleClick}
          onChange={onSearchChange}
        />
        <div className="add-player-to-team__players-list">
          {filteredUsers.map(user =>
            <button
              key={user._id}
              className="add-player-to-team__players-list__player"
              type="button"
              onClick={() => handleClick(user)}
            >
              <PlayerProfilePreview
                avatar={user.avatar}
                avatarBgColor={user.avatarBgColor}
                lastName={user.lastName}
                firstName={user.firstName}
                fullName={user.fullName}
              />
              <span className="add-player-to-team__players-list__player__name">{user.fullName}</span>
              <div className="add-player-to-team__players-list__player__checkbox-wrapper">
                <RoundCheckbox
                  isSelected={selectedUsersIds.includes(user._id)}
                />
              </div>
            </button>
          )}
        </div>
        <ButtonsPanel 
          usersCount={selectedUsersIds.length}
          onAdd={()=> onAddUsers(selectedUsersIds)}
          onInvite={onInvite}
          inviteButtonText={`Invite new ${accountType}`}
        />
      </div>
    </DarkScreenMask>
  );
};

AddPlayerToTeamModal.propTypes = {
  accountType: PropTypes.string, 
  isVisible: PropTypes.bool,
  onAddUsers: PropTypes.func,
  onClose: PropTypes.func,
  users: PropTypes.array
};

AddPlayerToTeamModal.defaultProps = {
  accountType: "", 
  isVisible: false,
  onAddUsers: () => {},
  onClose: () => {},
  users: []
}

export default AddPlayerToTeamModal;